import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import AdminDashboard from '../pages/AdminDashboard';
import Gallery from '../pages/Gallery';
import LessonsPage from '../pages/Student/LessonsPage';
import StudentHomework from '../pages/Student/StudentHomework';
import Scorecard from '../pages/Student/Scorecard';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import PaymentSuccess from '../pages/PaymentSuccess';
import PaymentCancel from '../pages/PaymentCancel';
import AdminRoute from './AdminRoute';
import PrivateRoute from './PrivateRoute';
import PageTransition from './PageTransition';

// Course Pages
import BeginnerCourse from '../pages/Courses/BeginnerCourse';
import IntermediateCourse from '../pages/Courses/IntermediateCourse';
import AdvancedCourse from '../pages/Courses/AdvancedCourse';

// Blog Pages
import BlogIndex from '../pages/Blog/BlogIndex';
import LearnTablaBeginners from '../pages/Blog/posts/LearnTablaBeginners';
import TablaPune from '../pages/Blog/posts/TablaPune';
import TablaForKids from '../pages/Blog/posts/TablaForKids';
import IntermediateTablaTips from '../pages/Blog/posts/IntermediateTablaTips';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/login" element={<PageTransition><Login /></PageTransition>} />
        <Route path="/register" element={<PageTransition><Register /></PageTransition>} />
        <Route path="/forgot-password" element={<PageTransition><ForgotPassword /></PageTransition>} />
        <Route path="/reset-password/:token" element={<PageTransition><ResetPassword /></PageTransition>} />
        <Route path="/gallery" element={<PageTransition><Gallery /></PageTransition>} />

        {/* Course Landing Pages */}
        <Route path="/courses/beginner" element={<PageTransition><BeginnerCourse /></PageTransition>} />
        <Route path="/courses/intermediate" element={<PageTransition><IntermediateCourse /></PageTransition>} />
        <Route path="/courses/advanced" element={<PageTransition><AdvancedCourse /></PageTransition>} />

        {/* Blog */}
        <Route path="/blog" element={<PageTransition><BlogIndex /></PageTransition>} />
        <Route path="/blog/learn-tabla-online-beginners" element={<PageTransition><LearnTablaBeginners /></PageTransition>} />
        <Route path="/blog/tabla-classes-pune-atharva-kagalkar" element={<PageTransition><TablaPune /></PageTransition>} />
        <Route path="/blog/online-tabla-classes-for-kids" element={<PageTransition><TablaForKids /></PageTransition>} />
        <Route path="/blog/intermediate-tabla-tips" element={<PageTransition><IntermediateTablaTips /></PageTransition>} />

        {/* Private Routes */}
        <Route
          path="/lessons"
          element={
            <PrivateRoute>
              <PageTransition><LessonsPage /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <PageTransition><Dashboard /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route
          path="/homework"
          element={
            <PrivateRoute>
              <PageTransition><StudentHomework /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route
          path="/scorecard"
          element={
            <PrivateRoute>
              <PageTransition><Scorecard /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route path="/pricing" element={<Navigate to="/register" replace />} />
        <Route path="/subscription/payment" element={<Navigate to="/register" replace />} />
        <Route
          path="/payment/success"
          element={
            <PrivateRoute>
              <PageTransition><PaymentSuccess /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route
          path="/payment/cancel"
          element={
            <PrivateRoute>
              <PageTransition><PaymentCancel /></PageTransition>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminRoute>
              <PageTransition><AdminDashboard /></PageTransition>
            </AdminRoute>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
